import { useRoute } from 'vue-router'
import { useTemplateStore } from 'src/stores'
import useNotify from 'src/hook/useNotify'
import { errorArrayGenerator } from 'src/common/helpers/generator/error.helper'
import { onBeforeMount, onBeforeUnmount, reactive } from 'vue'
import { useAxios } from 'src/services/__vue_query__/api/fetchByApiClient'
import { Endpoints } from 'src/services/__vue_query__/endpoints'
import { handleAxiosResponse } from 'src/services/__vue_query__/api/helpers'
import type {
  ITemplateFieldGroups,
  TemplateFieldsResponse,
  ITemplateFieldTypes,
  TemplateResponse,
  TemplateSizeType,
} from 'src/common/interfaces'

export default function useBaseTemplateHook() {
  const { notify } = useNotify()
  const rotue = useRoute()
  const templateStore = useTemplateStore()

  // this state use for toggling layers section in the smaller device screens
  const state = reactive({ isLayerOpen: true })

  // this method use for hidding layers section in the smaller device screens
  function handleHideLayer($event: Event) {
    if (state.isLayerOpen && ($event.target as HTMLElement)?.parentElement?.id !== 'toggle_layer_drawer')
      state.isLayerOpen = false
  }

  async function getData() {
    try {
      const templateRequest = useAxios<TemplateResponse>(Endpoints.SETTINGS_TEMPLATES_PORTAL_LIST, {
        filter: { id: rotue.params.id },
      })
      const templateFieldsRequest = useAxios<TemplateFieldsResponse>(Endpoints.SETTINGS_TEMPLATES_FIELDS, {
        filter: { type: 'order' },
      })
      await templateRequest.fetch()
      await templateFieldsRequest.fetch()
      const { data: templateData } = handleAxiosResponse<TemplateResponse>(templateRequest)
      const { data: templateFieldsData } = handleAxiosResponse<TemplateFieldsResponse>(templateFieldsRequest)

      const { items: templateLayers, images, size, name } = templateData.list[0]
      if (templateLayers.length)
        templateStore.handleSetLayers(templateStore.isDigitalMenu ? [templateLayers[0]] : templateLayers)
      if (images) templateStore.handleSetUploadedImageIds(images)
      templateStore.handleSetTemplateSize(size as TemplateSizeType)
      templateStore.handleSetTemplateName(name ?? '')
      templateStore.handleSetDigitalMenuKeys(templateData.list[0])

      const templateFields: ITemplateFieldGroups = { master: [], slave: [] }
      for (const fieldKey in templateFieldsData) {
        const key = fieldKey as ITemplateFieldTypes

        templateFields[key] = templateFieldsData[key].map((templateFields) => ({
          label: templateFields.title,
          value: templateFields,
        }))
      }
      templateStore.handleSetTemplateFields(templateFields)
    } catch (error) {
      const errors = errorArrayGenerator(error as string[] | Record<PropertyKey, unknown>)
      for (const errorMessage of errors) notify(false, errorMessage)
    }
  }

  onBeforeMount(async () => await getData())

  onBeforeUnmount(() => templateStore.$reset())

  return { state, handleHideLayer }
}
